import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import ResetSecretRoute from '~/features/auth/routes/ResetSecret.route';

export const Route = createFileRoute('/_auth/reset/secret/')({
    component: () => <ResetSecretRoute />,
    validateSearch: z.object({
        jwt: z.string(),
    }),
});
